import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Construction extends Entity {

  @deserializeAs(String, 'materiaux_murs')
  materiauxMurs: Array<string>;

  @deserializeAs(String, 'materiaux_toiture')
  materiauxToiture: Array<string>;

  @deserializeAs('superficie_habitable')
  superficieHabitable;

  @deserializeAs(Date, 'date_achevement')
  dateAchevement: Date;

  @deserializeAs(Date, 'date_depot_permis_construire')
  dateDepotPermisConstruire: Date;

  @deserializeAs(String, 'nature_dependances')
  natureDependances: Array<string>;

  @deserializeAs('nombre_niveaux')
  nombreNiveaux;

  @deserializeAs(String, 'raccordements_reseaux')
  raccordementsReseaux: Array<string>;

  @deserializeAs('nature_chauffage')
  natureChauffage;

  @deserializeAs('type_chauffage')
  typeChauffage;

  @deserializeAs('numero_permis_construire')
  numeroPermisConstruire;

  @deserializeAs('nature_eau_chaude')
  natureEauChaude;

  @deserializeAs('equipement_chauffage')
  equipementChauffage;

  @deserializeAs('type_eau_chaude')
  typeEauChaude;

  @deserializeAs('type_climatisation')
  typeClimatisation;

  @deserializeAs(Boolean, 'ascenseur')
  ascenseur;

}
